import { registerEvents } from "./skyward.ui.events";
import { JQueryInput, Skyward } from "./types";

window.skyward ??= {} as Skyward;
const skyward = window.skyward;
skyward.electronicSignature = skyward.electronicSignature || {};

const classNames =
{
    electronicSignatureAgreeCheckbox: '.electronicSignatureAgreeCheckbox',
    electronicsignature: '.electronicsignature',
    validationList: '.validationList',
    electronicSignatureSignedBy: '.electronicSignatureSignedBy',
    electronicSignatureDateSigned: '.electronicSignatureDateSigned',
    electronicSignatureToggledByCurrentUser: '.electronicSignatureToggledByCurrentUser'
};

const fieldSetConstants =
{
    systemDateTime: '/SkySys/ConfigSystem/GetSystemDateTime',
    post: 'POST',
    errorControl: 'error-control',
    checked: 'checked',
    change: 'change'
};

registerEvents("electronicSignature", {});

export function registerElectronicSignatureAgreeCheckboxEvent(selectorElement: JQueryInput)
{
    $(selectorElement).on(fieldSetConstants.change, function () {
        var esContainer = $(this).closest(classNames.electronicsignature);
        electronicSignatureAgreeCheckboxChanged(esContainer);
    });
}

export function selectErrorListForElectronicSignatureMessageValidation(selectorElement: JQueryInput)
{
    $(selectorElement).each(function () {
        var errorList = $(this);
        errorList.remove();
    });
}

function electronicSignatureAgreeCheckboxChanged(esContainer: JQuery<HTMLElement>)
{
    var checkbox = esContainer.find(classNames.electronicSignatureAgreeCheckbox);
    var signedByTextbox = esContainer.find(classNames.electronicSignatureSignedBy);
    var dateSignedTextbox = esContainer.find(classNames.electronicSignatureDateSigned);
    var signedByUserIdValue = esContainer.find(classNames.electronicSignatureToggledByCurrentUser);
    skyward.controls.setValue(signedByUserIdValue, true);

    var isChecked = checkbox.prop(fieldSetConstants.checked);
    if (isChecked) {
        skyward.controls.disable(checkbox);

        $.ajax({
            url: skyward.global.virtualDir + fieldSetConstants.systemDateTime,
            type: fieldSetConstants.post,
            success: function (data) {
                skyward.controls.setValue(signedByTextbox, esContainer.data().userName);
                skyward.controls.setValue(dateSignedTextbox, data.systime);
            },
            complete: function () {
                skyward.controls.enable(checkbox);
            }
        });
    }
    else {
        skyward.controls.clearValue(signedByTextbox);
        skyward.controls.clearValue(dateSignedTextbox);
        dateSignedTextbox.removeClass(fieldSetConstants.errorControl);
    }
};
